import { axiosInstance } from "../axios_Instanse";
import { popupMessagesHandler } from "../Orders/OrderActionCreators";

import Store from "../Store";
// import socketIo from "socket.io-client";
import { authLessAxios } from "./AuthLessAxios";

import {
  authUnauthorizedMessage,
  currentOffice,
  getRecoverCode,
  officeAuth,
  setCaptchaCode,
  setLoginOTP,
  setRegisterAddress,
  setRegisterOTP,
  setRegisterStage,
  setResetCaptcha,
  setTraceCode,
} from "./LoginActionCreators";
import { socket } from "../Socket/socket";
// import { socket } from "../Socket/socket";
// import { io } from "socket.io-client";
// import { socket } from "../Socket/socket";

export const setAuthToken = async (values) => {
  try {
    Store.dispatch(authUnauthorizedMessage(null));
    const loginData = await axiosInstance.post("/login", {
      "g-recaptcha-response": Store.getState().loginReducer.captchaCode,
      ...values,
    });
    ["token", "profile", "recall_interval_timer", "menu", "timeout"].forEach(
      (item) => {
        localStorage[item] =
          item === "menu" || item === "profile"
            ? JSON.stringify(loginData.data[item])
            : loginData.data[item];
      }
    );
    Store.dispatch(officeAuth(true));
    axiosInstance.defaults.headers["token"] = loginData.data.token;
    Store.dispatch(currentOffice(loginData.data.board_title));

    socket(loginData.data.token);

    return loginData.data;
  } catch (err) {}
};

export const SubmitRegister = async (value) => {
  const { resetCaptcha } = Store.getState().loginReducer;
  try {
    await authLessAxios.post("/try_register", {
      "g-recaptcha-response": Store.getState().loginReducer.captchaCode,
      ...value,
    });
    Store.dispatch(setResetCaptcha(resetCaptcha + 1));
    Store.dispatch(setRegisterOTP("get"));
    Store.dispatch(setCaptchaCode(""));
  } catch (error) {}
};

export const confirm_register = async (values) => {
  try {
    await authLessAxios.post("/confirm_try_register", {
      "g-recaptcha-response": Store.getState().loginReducer.captchaCode,
      username: Store.getState().loginReducer.Register_Mobile_Email,
      ...values,
    });
    Store.dispatch(setRegisterStage(1));
    Store.dispatch(setRegisterOTP("come"));
  } catch (error) {}
};

export const submitRegisterStages = async (value) => {
  const username = Store.getState().loginReducer.Register_Mobile_Email;
  try {
    const { lat, lng } = Store.getState().loginReducer.lat_lng;

    const submit = await authLessAxios.post("/register", {
      username,
      lat,
      lng,
      ...value,
    });

    Store.dispatch(setTraceCode(submit.data));
    Store.dispatch(setRegisterStage(4));
  } catch (error) {}
};

export const getRegisterAddress = async (values) => {
  try {
    const data = await authLessAxios.get(
      `/point_to_address?lat=${values[0].lat}&lng=${values[0].lng}&username=${values[1]}`
    );

    Store.dispatch(
      setRegisterAddress({
        address: data.data.addresses[0].formatted,
        district: data.data.municipality_zone,
        city: data.data.city,
        province: data.data.state,
      })
    );
  } catch (error) {}
};

export const recoverPassWord = async (values) => {
  try {
    let { data } = await authLessAxios.post("/try_forget", {
      "g-recaptcha-response": Store.getState().loginReducer.captchaCode,
      ...values,
    });
    Store.dispatch(getRecoverCode(2));
    Store.dispatch(setCaptchaCode(""));
    return data;
  } catch (error) {}
};

export const confirm_forget = async (values) => {
  const username = Store.getState().loginReducer.recoverLoginContact;
  try {
    await authLessAxios.post(`/confirm_forget`, {
      username,
      ...values,
    });
    Store.dispatch(setLoginOTP(values));
    Store.dispatch(getRecoverCode(3));
    Store.dispatch();
    Store.dispatch(setCaptchaCode(""));
  } catch (error) {}
};

export const ResetPassword = async (value) => {
  const username = Store.getState().loginReducer.recoverLoginContact;
  try {
    const data = await authLessAxios.post("/reset_password", {
      username,
      ...value,
    });
    Store.dispatch(authUnauthorizedMessage(data.data));
    Store.dispatch(
      popupMessagesHandler({
        mode: true,
        message: data.data,
        color: "info",
      })
    );
    return data;
  } catch (error) {}
};

export const LogOut = async () => {
  try {
    const data = await axiosInstance.get("/logout");
    // closeSocket();
    return data.data;
  } catch (error) {}
};

export const edit_personal_profile = async (value) => {
  try {
    let { data } = await axiosInstance.post("/profile", value);

    Store.dispatch(
      popupMessagesHandler({
        mode: true,
        message: data,
        color: "success",
      })
    );
    return data;
  } catch (error) {}
};
